export default __webpack_public_path__ + "static/media/hyperVideo.a4458ce0.mp4";